import zod from 'zod';

export const WebRtcSchemas = {
    Publisher: zod.object({}),
    Consumer: zod.object({}),
};
